import React from 'react'
import { Row, Col, Container } from 'react-bootstrap'
import { useLocation, useNavigate } from 'react-router-dom'
import ProductZoomView from '../../../components/common/ProductZoomView'

export default function ProductView() {
  const navigate = useNavigate()
  const state = useLocation().state || {}
  React.useEffect(() => {
    if (!state.id) {
      navigate('/products')
    } else {
      window.scrollTo({ top: 0 })
    }
  }, [state])

  return (
    <Container className='p-4 py-2 pt-5 mt-2'>
      <div className='text-bold'>Home / Products</div>
      <Row className='mb-5'>
        <Col md={6} className='my-1 my-md-2 my-lg-3 p-1 p-md-2 p-lg-3'>
          <ProductZoomView
            images={state.images}
            thumbnail={state.thumbnail}
            name={state.name}
          />
          {/* <Image src={} /> */}
        </Col>
        <Col md={6} className='my-1 my-md-2 my-lg-3 p-1 p-md-2 p-lg-3'>
          <div className='p-3 bg-white position-relative'>
            <h4>{state.name}</h4>
            <p
              className='mt-2 dangerouslySetInnerHTML'
              dangerouslySetInnerHTML={{ __html: state.description }}
            />
            <div className='mt-4 text-bold'>Additional Information</div>
            <hr className='mt-1' />
            <div>
              <span className='text-bold'>Price:</span> {state.price} TK
            </div>
            <div>
              <span className='text-bold'>Weight:</span> {state.weight}
            </div>
            <div>
              <span className='text-bold'>Code:</span> {state.code}
            </div>
          </div>
        </Col>
      </Row>
    </Container>
  )
}
